// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__BRN+H","moving":"Loading_moving__8aDa5"};